export const ESTABLISHMENT_ACTIVITY = {
  TRAVEL_SERVICE: "TRAVEL_SERVICE",
  ACCOMMODATION_SERVICE: "ACCOMMODATION_SERVICE",
};

export const ESTABLISHMENT_ACTIVITY_OPTIONS = [
  { value: ESTABLISHMENT_ACTIVITY.TRAVEL_SERVICE, label: "Services de voyage" },
  { value: ESTABLISHMENT_ACTIVITY.ACCOMMODATION_SERVICE, label: "Hébergement" },
];

export function activityLabel(value) {
  return ESTABLISHMENT_ACTIVITY_OPTIONS.find((o) => o.value === value)?.label || value;
}
